import { Col, Divider, Form, Row } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { updateOverChargeClaimInProgress } from '../../../../../../../../redux/Claims/OverCharge/OverChargeActions';
import { formFlagToBoolean } from '../../../../../../../../utilz';
import { overChargeClaimsDetailsSectionLocalToAPI } from '../../../../../../../../utilz/OverChargeClaimUtils';
import { convertESTToLocalTime } from '../../../../../../../../utilz/dates';
import { routeFileSelector } from '../../../../../../../../utilz/i18n';
import Button from '../../../../../../../components/Buttons/Button';
import PrimaryLabel from '../../../../../../../components/Labels/PrimaryLabel';
import SaveCancelButtons from '../../../../../../Shipment/components/SaveCancelButtons';
import OurClaimForm from './OurClaimForm';
import YourClaimForm from './YourClaimForm';

const OverChargeDetails = () => {
  const dispatch = useDispatch();
  const [editMode, setEditMode] = useState(false);
  const [form] = Form.useForm();
  const { claimDetails } = useSelector((state) => state.overChargeClaims);

  const handleSubmit = (data) => {
    const handleSuccess = () => {
      setEditMode(false);
    };
    let formData = overChargeClaimsDetailsSectionLocalToAPI(data);
    formData = { ...claimDetails.data, ...formData, handleSuccess };
    formData.isRefetchDetails = true;
    dispatch(updateOverChargeClaimInProgress(formData));
  };

  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const handleFormSetValue = (data) => {
    form.setFieldsValue({
      currencyCode: data?.currencyCode,
      statusCode: data?.statusCode,
      reasonCode: data?.reasonCode,
      ocTypeKey: data?.ocTypeKey,
      auditedBy: data?.auditedBy,
      dateSubmitted: convertESTToLocalTime(data?.dateSubmitted) ?? undefined,
      carrierClaimNo: data?.carrierClaimNo,
      carrierKey: data?.carrierKey,
      carrierName: data?.carrierName,
      carrierEmail: data?.carrierEmail,
      carrierDisplayAddress: data?.carrierDisplayAddress,
      fbAttach: formFlagToBoolean(data?.fbAttach),
      bolAttach: formFlagToBoolean(data?.bolAttach),
      invAttach: formFlagToBoolean(data?.invAttach),
      otherAttach: formFlagToBoolean(data?.otherAttach),
      otherDesc: data?.otherDesc,
      checkNoFromCarrier: data?.checkNoFromCarrier,
      checkNoToCustomer: data?.checkNoToCustomer,
      ammendmentDate: convertESTToLocalTime(data?.ammendmentDate) ?? undefined,
      closedDate: convertESTToLocalTime(data?.closedDate) ?? undefined,
      checkDateToCustomer: convertESTToLocalTime(data?.checkDateToCustomer) ?? undefined,
    });
  };

  useEffect(() => {
    if (claimDetails?.data?.fbOcKey) {
      handleFormSetValue(claimDetails?.data);
    }
  }, [claimDetails]);

  const handleCancel = () => {
    handleFormSetValue(claimDetails?.data);
    setEditMode(false);
  };

  return (
    <div className="d-flex  py-16 h-100" style={{ flexDirection: 'column' }}>
      <Row className="px-30 align-items-center" justify="space-between">
        <Col>
          <PrimaryLabel className="fw-700 f-18">{t('translation:claims.Details')}</PrimaryLabel>
        </Col>
        <Col>
          <Row justify="end" gutter={16}>
            <Col>
              {editMode ? (
                <SaveCancelButtons
                  editMode={editMode}
                  setEditMode={setEditMode}
                  onSave={() => form.submit()}
                  onCancel={handleCancel}
                />
              ) : (
                <Button onClick={() => setEditMode(true)}>{t('translation:default.buttons.edit')}</Button>
              )}
            </Col>
          </Row>
        </Col>
      </Row>
      <Divider className="mt-0 my-16 ml-n16 vw-100 " />
      <div className="flex-1 custom-scroll-bar">
        <Form onFinish={handleSubmit} form={form} className="px-30">
          <OurClaimForm editMode={editMode} setEditMode={setEditMode} claimDetails={claimDetails?.data} form={form} />
          <Divider className="my-16 w-100" dashed />
          <YourClaimForm editMode={editMode} setEditMode={setEditMode} claimDetails={claimDetails?.data} form={form} />
        </Form>
      </div>
    </div>
  );
};

export default OverChargeDetails;
